"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationType = void 0;
var OperationType;
(function (OperationType) {
    OperationType["NUM_GT"] = ">";
    OperationType["NUM_GTE"] = ">=";
    OperationType["NUM_LT"] = "<";
    OperationType["NUM_LTE"] = "<=";
    OperationType["NUM_BETWEEN"] = "between";
    OperationType["NUM_EQ"] = "=";
    OperationType["STRING_MATCHES"] = "matches";
    OperationType["STRING_CONTAINS"] = "contains";
    OperationType["STRING_ENDS_WITH"] = "endsWith";
    OperationType["STRING_REGEX"] = "iRegexIn";
    OperationType["DATE_BEFORE"] = "before";
    OperationType["DATE_INLAST"] = "inLast";
    OperationType["DATE_BETWEEN"] = "between";
    OperationType["DATE_COMING_UP_IN_NEXT"] = "comingUpInNext";
    OperationType["DATE_IN_NEXT_YEAR_NUM_SHIFT"] = "inNextNoYearShift";
})(OperationType || (exports.OperationType = OperationType = {}));



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/cohort-rule/operation-type.js
// module id = 1250
// module chunks = 0